import React from "react";
import {
  Button,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { FIELD_TYPES, GROUPS } from "./fieldTypes";

// Paleta: os tipos que dá para adicionar, agrupados por finalidade. Um clique
// adiciona o campo ao fim da lista (ou depois do selecionado) e já o seleciona
// no inspetor — o construtor antigo obrigava a preencher tudo ANTES de ver o
// campo existir.
class Palette extends React.Component {
  render() {
    const { classes, onAdd } = this.props;

    return (
      <div className={classes.container}>
        <Typography variant="subtitle2" className={classes.title}>
          Adicionar campo
        </Typography>
        {GROUPS.map((group) => (
          <div key={group} className={classes.group}>
            <Typography variant="caption" className={classes.groupTitle}>
              {group}
            </Typography>
            <List dense disablePadding>
              {FIELD_TYPES.filter((definition) => definition.group === group).map(
                (definition) => (
                  <Tooltip
                    key={definition.type}
                    title={definition.description}
                    placement="right"
                  >
                    <ListItem
                      button
                      disableGutters
                      className={classes.item}
                      onClick={() => onAdd(definition.type)}
                    >
                      <AddIcon fontSize="small" className={classes.icon} />
                      <ListItemText
                        primary={definition.label}
                        primaryTypographyProps={{ variant: "body2" }}
                      />
                    </ListItem>
                  </Tooltip>
                )
              )}
            </List>
          </div>
        ))}
        <Button
          size="small"
          fullWidth
          className={classes.settings}
          onClick={this.props.onOpenSettings}
        >
          Dados do formulário
        </Button>
      </div>
    );
  }
}

const styles = (theme) => ({
  container: {
    padding: theme.spacing(1),
  },
  title: {
    fontWeight: 700,
    padding: theme.spacing(0, 1, 1),
  },
  group: {
    marginBottom: theme.spacing(1),
  },
  groupTitle: {
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    paddingLeft: theme.spacing(1),
  },
  item: {
    paddingLeft: theme.spacing(1),
    borderRadius: 4,
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  settings: {
    marginTop: theme.spacing(1),
  },
});

export default withStyles(styles)(Palette);
